import { useStyletron } from "baseui";
import type { StyledSvg } from "baseui/icon";
import React from "react";

export const ErrorCircleIcon = (props: React.ComponentProps<typeof StyledSvg>) => {
  const [_css, $theme] = useStyletron();

  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.0001 0.599976C3.4657 0.599976 0.600098 3.46558 0.600098 6.99998C0.600098 10.5344 3.4657 13.4 7.0001 13.4C10.5345 13.4 13.4001 10.5344 13.4001 6.99998C13.4001 3.46558 10.5345 0.599976 7.0001 0.599976ZM7.6465 3.26664L7.53983 8.06664H6.46036L6.3537 3.26664H7.6465ZM7.0017 10.8341C6.5601 10.8341 6.2961 10.5989 6.2961 10.2037C6.2961 9.80104 6.55956 9.56584 7.0017 9.56584C7.4401 9.56584 7.70356 9.80104 7.70356 10.2037C7.70356 10.5989 7.4401 10.8341 7.0017 10.8341Z"
        fill={props.color || $theme.colors.yellow600}
      />
    </svg>
  );
};
